import { TFunction } from 'react-i18next';
import { mappingCardStatuses } from './mappingCardStatuses';

const mappingCardStatusesValues = (t: TFunction, selectedStatusFilter?: number) => {
  const statusesList = Object.entries(mappingCardStatuses(t));
  const selectedStatusLabel = statusesList.find(item => item[1].filterStatus.value === selectedStatusFilter)![1]
    .filterStatus.label;
  return statusesList.reduce((acc: any, [key, item]) => {
    if (item.filterStatus.label === selectedStatusLabel) {
      acc.push(key);
    }
    return acc;
  }, []);
};

export { mappingCardStatusesValues };
